<template>
  <button
    type="button"
    class="net-sidebar-toggle-button"
    @click="toggleSidebar"
  >
    <lucide-icon :name="sidebarClosed ? 'menu' : 'arrow-left'" />
  </button>
</template>

<script setup lang="ts">
import { computed } from "vue";
import LucideIcon from "@core/ui/LucideIcon.vue";
import { useNetStore } from "@editor/net/net.store";

const netStore = useNetStore();
const sidebarClosed = computed(() => netStore.sidebarClosed);

function toggleSidebar() {
  netStore.set({ sidebarClosed: !netStore.sidebarClosed });
}
</script>

<style lang="scss">
.net-sidebar-toggle-button {
  position: absolute;
  top: 1rem;
  left: 1rem;
  appearance: none;
  background-color: var(--color-background-close);
  border: none;
  border-radius: 0.25rem;
  padding: 0.5rem;
  margin-bottom: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: var(--color-text);
  transition: transform 200ms;

  &:hover {
    transform: scale(1.1);
  }
  &:active {
    transform: scale(0.98);
    transition: transform 100ms;
  }
}
</style>